export default function Verification() {
    return <div>Verification</div>;
}
